import { useClient } from '@composables/use-clients';
import {
  GetRequestArgsType,
  PostRequestArgsType,
} from '@api/v1/types';
import { useTenantStore } from '@stores/tenant-store';
import { urls } from '@api/urls';
import { withTryCatch } from '@api/v1/error-handlers';

export type GetRevieweeStatesArgsType = GetRequestArgsType & {
  reviewCode: string;
  revieweeId?: number | null;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type PostRevieweeStateArgsType = PostRequestArgsType<any> & {
  reviewCode: string;
  revieweeId: number;
};

export const apiFetchRevieweeStates = async ({
  domain = useTenantStore().domain,
  reviewCode,
  revieweeId = null,
  query = {},
  errorConfig = {},
  callbacks = {},
}: GetRevieweeStatesArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.get({
      url: urls.v1.revieweeStates({ domain, reviewCode, revieweeId }),
      query,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};

export const apiCompleteReview = async ({
  domain = useTenantStore().domain,
  reviewCode,
  revieweeId,
  errorConfig = {},
  callbacks = {},
}: PostRevieweeStateArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.post({
      url: urls.v1.revieweeStates({ domain, reviewCode, revieweeId }),
      payload: {},
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
